import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface ReferredAccount {
  _id: string
  name: string
  email: string
  phone: string
  created_at: string
  trial_period_end: string
}

export interface ReferrerRow {
  _id: string
  name: string
  email: string
  phone: string
  is_affiliate: boolean
  affiliate_code: string
  count: number
  latest: string
  referred: ReferredAccount[]
}

export interface ReferrersResponse {
  referrers: ReferrerRow[]
  total_referrers: number
  total_referred: number
}

export const getReferrers = (sort: 'latest' | 'count' = 'latest') =>
  adminApi.get<ReferrersResponse>(`${API_URL}/admin/referrers`, {params: {sort}})
